var map = {
	"./1.jpg": "38f3",
	"./2.jpg": "cedd",
	"./3.jpg": "a760",
	"./4.jpg": "ab86",
	"./team_bg.jpg": "81d1",
	"./zl_bg.jpg": "02c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d1e";